export default class Reviews {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Reloads Widgets
  //===========================================================================

  reloadReviewsWidget() {
    // Shopify Reviews

    if (window.SPR) {
      SPR.registerCallbacks();
      SPR.initRatingHandler();
      SPR.initDomEls();
      SPR.loadProducts();
      SPR.loadBadges();
    }

    // Yotpo Reviews

    if (window.Yotpo?.API) {
      let yotpoApi = new Yotpo.API(yotpo);
      yotpoApi.refreshWidgets();
    }

    // Yotpo Rewards

    if (window.yotpoWidgetsContainer?.initWidgets) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('reloadReviewsWidget', this.reloadReviewsWidget.bind(this));
    $(document).on('historyChange', this.reloadReviewsWidget.bind(this));
  }
}
